import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { memo } from 'react';

interface TableBodyEmptyInterface {
  emptyMessage?: String;
}

function TableBodyEmpty({ emptyMessage }: TableBodyEmptyInterface) {

  return (
    <TableBody>
      <TableRow >
        <TableCell component="th" scope="row" colSpan={12} align='center'>
          {emptyMessage || 'Nenhum dado a ser exibido'}
        </TableCell>
      </TableRow>
    </TableBody>
  );
}

export default memo(TableBodyEmpty);
